import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import RedirectActions, { redirect } from '@common/utils/redirect/redirect.actions';

@Injectable()
export class RedirectEffects {
    private readonly actions$ = inject(Actions);

    redirect$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(RedirectActions.redirectToUrl, redirect),
                tap(({ url }) => (window.location.href = url))
            ),
        { dispatch: false }
    );
}
